import { FaSort as SortIcon } from 'react-icons/fa';

export default SortIcon;
